var $35da740d59af89ba$exports = {};
function $35da740d59af89ba$var$toClassNames(obj) {
    return Object.entries(obj).filter(([_key, value])=>value).map(([key, value])=>`${key}__${value}`).join(" ");
}
// Get an ID and KEY pair by signing up at https://developer.tmb.cat/
const $35da740d59af89ba$var$TMB_APP_ID = "8e772826";
const $35da740d59af89ba$var$TMB_APP_KEY = "9c9838269e50f9a6abc535bfa7d11b99";
class $35da740d59af89ba$var$Route {
    constructor({ agency: agency, family: family, code: code }){
        this.agency = agency;
        this.family = family;
        this.code = code;
    }
    static TMB(code) {
        const family = {
            "H": "H",
            "V": "V",
            "D": "D",
            "X": "X"
        }[code[0]];
        return new $35da740d59af89ba$var$Route({
            agency: "TMB",
            family: family,
            code: code
        });
    }
    classNames() {
        return $35da740d59af89ba$var$toClassNames({
            agency: this.agency,
            family: this.family,
            code: this.code
        }) + " departure-route";
    }
    render() {
        const element = document.createElement("div");
        element.className = this.classNames();
        const code = document.createElement("span");
        code.textContent = this.code;
        element.appendChild(code);
        return element;
    }
}
class $35da740d59af89ba$var$Departure {
    constructor({ route: route, destination: destination, minutes: minutes }){
        this.route = route;
        this.destination = destination;
        this.minutes = minutes;
    }
    render() {
        const element = document.createElement("div");
        element.className = "departure";
        const route = this.route.render();
        element.appendChild(route);
        const destinationDiv = document.createElement("div");
        destinationDiv.className = "departure-destination";
        const destination = document.createElement("span");
        destination.textContent = this.destination;
        destinationDiv.appendChild(destination);
        element.appendChild(destinationDiv);
        const minutesDiv = document.createElement("div");
        minutesDiv.className = "departure-minutes";
        const minutes = document.createElement("span");
        minutes.textContent = this.minutes + " min";
        minutesDiv.appendChild(minutes);
        element.appendChild(minutesDiv);
        return element;
    }
}
class $35da740d59af89ba$var$DepartureList {
    constructor(){
        this.departures = [];
    }
    static from(departures) {
        const list = new $35da740d59af89ba$var$DepartureList();
        departures.forEach((departure)=>list.addDeparture(departure));
        return list;
    }
    addDeparture(departure) {
        this.departures.push(departure);
    }
    sortDepartures() {
        this.departures.sort((a, b)=>a.minutes - b.minutes);
    }
    render() {
        this.sortDepartures();
        const list = document.createElement("div");
        list.className = "departure-list";
        this.departures.forEach((departure)=>{
            const element = departure.render();
            list.appendChild(element);
        });
        return list;
    }
}
class $35da740d59af89ba$var$Query {
    constructor(stopQueries){
        this.stopQueries = stopQueries;
    }
    async fetchDepartures() {
        const promises = this.stopQueries.map((stopQuery)=>stopQuery.fetchDepartures());
        const departures = await Promise.all(promises);
        return $35da740d59af89ba$var$DepartureList.from(departures.flat());
    }
}
class $35da740d59af89ba$var$StopQuery {
    constructor({ stop: stop, routes: routes = true }){
        this.stop = stop;
        this.routes = routes;
    }
    async fetchDepartures() {
        const url = [
            `https://api.tmb.cat/v1/ibus/stops/${this.stop}`,
            `?numberOfPredictions=2`,
            `&app_id=${$35da740d59af89ba$var$TMB_APP_ID}`,
            `&app_key=${$35da740d59af89ba$var$TMB_APP_KEY}`
        ].join("");
        const response = await fetch(url);
        const data = await response.json();
        const departures = [];
        data.data.ibus.forEach((departure)=>{
            if (this.routes === true || this.routes && this.routes.includes(departure.line)) {
                if (departure["t-in-min"] > 0) departures.push(new $35da740d59af89ba$var$Departure({
                    route: $35da740d59af89ba$var$Route.TMB(departure.line),
                    destination: departure.destination,
                    minutes: departure["t-in-min"]
                }));
            }
        });
        return departures;
    }
}
function $35da740d59af89ba$var$renderTo(element, renderable) {
    element.innerHTML = "";
    element.appendChild(renderable.render());
}
const $35da740d59af89ba$var$query = new $35da740d59af89ba$var$Query([
    new $35da740d59af89ba$var$StopQuery({
        stop: 1224,
        routes: [
            "33",
            "34",
            "H10"
        ]
    })
]);
async function $35da740d59af89ba$var$renderQuery() {
    const departureList = await $35da740d59af89ba$var$query.fetchDepartures();
    const container = document.getElementById("root");
    $35da740d59af89ba$var$renderTo(container, departureList);
}
window.addEventListener("load", ()=>{
    $35da740d59af89ba$var$renderQuery();
    setInterval(()=>$35da740d59af89ba$var$renderQuery(), 30000);
    const body = document.querySelector("body");
// body.addEventListener("click", () => {
//   body.requestFullscreen({ navigationUI: "hide" })
// });
});


//# sourceMappingURL=index.6c249004.js.map
